<template>
  <el-card shadow="hover">
    <label slot="header">时间选择器 {{`选中年${year}选中月${month}选中日期${date}`}}</label>
    <el-divider content-position="left">v-model="date" disabled-range="after"</el-divider>
    <j-date v-model="date" disabled-range="after" placeholder="选择日" :after-shortcuts="[7,10,15]" />
    <el-divider content-position="left">type="datetime" disabled-range="after"</el-divider>
    <j-date v-model="datetime" type="datetime" disabled-range="after" placeholder="选择日期时分秒" :after-shortcuts="[7,10,15]" />
    <el-divider content-position="left">type="month" disabled-range="before"</el-divider>
    <j-date v-model="month" type="month" value-format="yyyy-MM" disabled-range="before" placeholder="选择月" :before-shortcuts="[1,3,5]" />
    <el-divider content-position="left">type="year" disabled-range="before"</el-divider>
    <j-date v-model="year" type="year" value-format="yyyy" disabled-range="before" placeholder="选择年" :before-shortcuts="[2,5,8]" />
  </el-card>
</template>

<script>
import JDate from "./JDate";
export default {
  components: {
    JDate
  },
  data() {
    return {
      date: '2022-06-10',
      datetime: '',
      year: '',
      month: ''
    }
  },
  created() {

  },
  methods: {}
}
</script>

<style scoped>

</style>
